import { useNavigate } from "react-router-dom";
import { Button } from "../../../../core/components/Button";
import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";

export const HomeScreen: React.FC = () => {
	const navigate = useNavigate();
	const handleNavigate = (ref: string) => {
		navigate(ref);
	};
	return (
		<>
			<Row
				flexible
				className="relative"
				mainAxisAlignment="center"
				crossAxisAlignment="center"
			>
				<img
					className="w-full max-md:hidden absolute top-0 left-0 rotate-180"
					src="/olas-imagen.svg"
					alt="representacion del mundo contaminado"
				/>
				<img
					className="w-full max-md:hidden absolute bottom-0 left-0"
					src="/olas-imagen.svg"
					alt="representacion del mundo contaminado"
				/>
				<Row
					flexible
					mainAxisAlignment="center"
					crossAxisAlignment="center"
					className="relative self-center py-5 px-5 gap-5 sm:w-[40rem] md:w-[50rem] xl:w-[60rem] md:py-24 my-5 md:my-10"
					responsiveCol
				>
					<div className="text-[#12a0c427]" />

					<Column className="w-full md:w-1/2 z-[1]">
						<TextComponent
							variant="extraBig"
							className="font-title !leading-none"
							data-sal="zoom-out"
							data-sal-duration="1000"
						>
							TACNA Y SU <br /> <span className="text-green-600">AMBIENTE</span> <span className="text-cyan-600">MARINO</span>
						</TextComponent>
						{/* <hr className="w-full h-[2px] bg-black" /> */}
						<TextComponent
							variant="h1"
							className="font-title text-yellow-400 drop-shadow-xl"
							data-sal="zoom-out"
							data-sal-duration="1000"
						>
							❝Una riqueza que proteger❞
						</TextComponent>
					</Column>
					<img
						className="w-full md:w-1/2 z-[1]"
						data-sal="zoom-out"
						data-sal-duration="1000"
						src="/contaminacion-tierra.webp"
						alt="representacion del mundo contaminado"
					/>
				</Row>
			</Row>
			<Column
				crossAxisAlignment="center"
				className="bg-gradient-to-r from-cyan-600 to-blue-600 w-full py-10 px-5 gap-5 md:border-t-2 md:border-b-2 md:border-t-white md:border-b-white"
			>
				<Column crossAxisAlignment="center">
					<TextComponent
						variant="big"
						className="font-title text-center !leading-none text-white"
						data-sal="slide-right"
						data-sal-duration="1000"
					>
						Tacna está en riesgo
					</TextComponent>
					<TextComponent
						variant="h3"
						className="text-white uppercase"
						data-sal="slide-left"
						data-sal-duration="1000"
					>
						la cuenta regresiva a comenzado
					</TextComponent>
				</Column>
				<Row
					className="gap-5 sm:w-[40rem] md:w-[50rem] xl:w-[60rem]"
					responsiveCol
				>
					<Column
						className="md:w-2/3 bg-white p-4 md:p-10 rounded-lg"
						data-sal="slide-right"
						data-sal-duration="1000"
					>
						<TextComponent variant="h5">
							Los <span className="text-cyan-600 font-bold">océanos</span>, fuente de vida y motor del equilibrio <span className="text-blue-600 font-bold">ecológico</span> del planeta,
							se encuentran en peligro.
							<br /> <br />
							La degradación de los ecosistemas marinos avanza a un ritmo <span className="font-semibold text-red-600">alarmante</span> debido a la{" "}
							<span className="font-semibold">contaminación</span>, la <span className="font-semibold">sobrepesca</span>, la <span className="font-semibold">minería</span> y la{" "}
							<span className="font-semibold">destrucción de hábitats naturales</span>.
							<br /> <br />
							Cada año, <span className="font-bold text-yellow-600">millones de toneladas de plástico</span> inundan sus aguas, el depósito minero y los agentes orgánicos de la
							agricultura destruyen los arrecifes y miles de especies se ven <span className="text-red-600 font-bold">amenazadas</span>, alterando cadenas tróficas esenciales para la
							biodiversidad.
						</TextComponent>
					</Column>
					<img
						className="md:w-1/3 object-cover rounded-lg"
						src="/tortuga.jpg"
						data-sal="slide-left"
						data-sal-duration="1000"
						alt="representacion del mundo contaminado"
					/>
				</Row>
			</Column>
			<img
				className="w-full max-md:hidden rotate-180"
				src="/olas-imagen.svg"
				alt="representacion del mundo contaminado"
			/>

			<Row
				className="gap-5 md:gap-10 self-center max-md:mt-10 md:py-10 max-md:px-5 sm:w-[40rem] md:w-[50rem] xl:w-[60rem]"
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				responsiveCol
			>
				<Column
					className="md:w-3/5 bg-white  rounded-lg md:gap-4 gap-2"
					data-sal="slide-right"
					data-sal-duration="1000"
				>
					<TextComponent
						variant="h1"
						className="font-title"
					>
						Contaminación por el plástico
					</TextComponent>
					<TextComponent variant="h5">
						Los <span className="font-semibold text-yellow-600">plásticos</span> están a nuestro alrededor y forman parte de nuestra vida cotidiana. En la región de{" "}
						<span className="text-cyan-600 font-bold">Tacna</span>, la <span className="font-semibold text-red-600">contaminación plástica</span> afecta directamente nuestras{" "}
						<span className="font-semibold">playas y ecosistemas marinos</span>, poniendo en riesgo la <span className="font-semibold text-red-600">biodiversidad local</span> y la{" "}
						<span className="font-semibold text-blue-600">salud de la población</span>.
					</TextComponent>

					<Button
						color="blue"
						className="w-fit"
						onClick={() => handleNavigate("plastica")}
						secondary
					>
						Mas información →
					</Button>
				</Column>
				<img
					className="md:w-2/5 h-60 object-cover rounded-lg"
					src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjFJHqdjUskxnAESEb268kcHcGKSoYJcrutgD1eZaa6_qOqrEKTwMTQ2pyvKog1hnjENkwL0S9qj8Bd5crJ_q97JJXXnMsXQcHhHOqXcgzH_ZpnktUFS7iPUkMVim2OnAmntdC7nu-ZW_sw/s1600/oceano_contaminacion.png"
					alt="representacion de la contaminación por plastico"
					data-sal="slide-left"
					data-sal-duration="1000"
				/>
			</Row>
			<Row
				className="gap-5 md:gap-10 self-center max-md:mt-10 md:my-10 max-md:px-5 sm:w-[40rem] md:w-[50rem] xl:w-[60rem]"
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				responsiveCol
			>
				<Column
					className="md:w-2/5 gap-1"
					data-sal="slide-right"
					data-sal-duration="1000"
				>
					<img
						className="object-cover rounded-lg  h-60 "
						src="https://pbs.twimg.com/media/E3n9-KyXoAobRKg?format=jpg&name=medium"
						alt="representacion de la contamiinación minera"
					/>
					<TextComponent
						variant="h6"
						className="text-center"
					>
						El Río Sama
					</TextComponent>
				</Column>
				<Column
					className="md:w-3/5 bg-white  rounded-lg md:gap-4 gap-2 max-md:order-first"
					data-sal="slide-left"
					data-sal-duration="1000"
				>
					<TextComponent
						variant="h1"
						className="font-title"
					>
						Contaminación minera
					</TextComponent>
					<TextComponent variant="h5">
						La <span className="font-semibold text-red-600">minería</span> se ha convertido en una <span className="font-bold text-red-600">amenaza creciente</span> para los océanos,
						impulsada por la demanda de minerales como <span className="font-semibold text-yellow-600">cobre, molibdeno, níquel y tierras raras</span>, usados en tecnologías verdes y
						electrónicos. Sin embargo, esta actividad <span className="font-semibold text-red-600">destruye hábitats únicos</span>,{" "}
						<span className="font-semibold text-red-600">contamina el agua</span> y pone en riesgo la <span className="font-semibold text-red-600">biodiversidad marina</span>.
					</TextComponent>

					<Button
						color="blue"
						className="w-fit"
						onClick={() => handleNavigate("minera")}
						secondary
					>
						Mas información →
					</Button>
				</Column>
			</Row>
			<Row
				className="gap-5 md:gap-10 self-center max-md:mt-10 md:my-10 max-md:px-5 sm:w-[40rem] md:w-[50rem] xl:w-[60rem]"
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				responsiveCol
			>
				<Column
					className="md:w-3/5 bg-white  rounded-lg md:gap-4 gap-2 max-md:order-first"
					data-sal="slide-right"
					data-sal-duration="1000"
				>
					<TextComponent
						variant="h1"
						className="font-title"
					>
						Pesca indiscriminada
					</TextComponent>
					<TextComponent variant="h5">
						La <span className="font-semibold text-red-600">pesca indiscriminada o no controlada</span> es una de las <span className="font-bold text-red-600">mayores amenazas</span> para
						los océanos, provocando el <span className="font-semibold text-red-600">colapso de poblaciones de peces</span>, la{" "}
						<span className="font-semibold text-red-600">destrucción de hábitats</span> y el{" "}
						<span className="font-semibold text-red-600">desequilibrio de ecosistemas marinos enteros</span>. Cada año, se extraen{" "}
						<span className="font-bold text-yellow-600">90 millones de toneladas de peces</span>, y más del <span className="font-bold text-red-600">34%</span> de las poblaciones pesqueras
						están <span className="font-semibold text-red-600">sobreexplotadas</span> (FAO, 2023).
					</TextComponent>
					<Button
						color="blue"
						className="w-fit"
						onClick={() => handleNavigate("pesca")}
						secondary
					>
						Mas información →
					</Button>
				</Column>
				<img
					className="object-cover rounded-lg md:w-2/5 h-60"
					data-sal="slide-left"
					data-sal-duration="1000"
					src="https://imagenagropecuaria.com/wp-content/uploads/2019/05/pescadores.jpg"
					alt="representacion de la contamiinación minera"
				/>
			</Row>
			<Row
				className="gap-5 md:gap-10 self-center max-md:mt-10 md:my-10 max-md:px-5 sm:w-[40rem] md:w-[50rem] xl:w-[60rem]"
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				responsiveCol
			>
				<img
					data-sal="slide-right"
					data-sal-duration="1000"
					className="object-cover rounded-lg md:w-2/5 h-60"
					src="https://iresiduo.com/sites/default/files/styles/thumbnail-830x455/public/rios_y_residuos_plasticos.jpg?itok=hQXyHF54"
					alt="representacion de la contamiinación por agroquímicos"
				/>
				<Column
					className="md:w-3/5 bg-white  rounded-lg md:gap-4 gap-2 max-md:order-first"
					data-sal="slide-left"
					data-sal-duration="1000"
				>
					<TextComponent
						variant="h1"
						className="font-title"
					>
						Contaminación por agroquímicos
					</TextComponent>
					<TextComponent variant="h5">
						Los <span className="font-semibold text-cyan-600">océanos</span>, que cubren más del <span className="font-bold text-yellow-600">70%</span> del planeta, enfrentan una{" "}
						<span className="font-bold text-red-600">amenaza silenciosa pero devastadora</span>: la <span className="font-semibold text-red-600">contaminación de origen agrícola</span>.
						Aunque la agricultura es esencial para la alimentación humana, sus prácticas <span className="font-semibold text-red-600">intensivas</span> están degradando los{" "}
						<span className="font-semibold">ecosistemas marinos</span> a un ritmo <span className="font-bold text-red-600">alarmante</span>.
					</TextComponent>

					<Button
						color="blue"
						className="w-fit"
						onClick={() => handleNavigate("agroquimica")}
						secondary
					>
						Mas información →
					</Button>
				</Column>
			</Row>
			<Row
				className="gap-5 md:gap-10 self-center max-md:mt-10 md:my-10 max-md:px-5 sm:w-[40rem] md:w-[50rem] xl:w-[60rem]"
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				responsiveCol
			>
				<Column
					className="md:w-3/5 bg-white  rounded-lg md:gap-4 gap-2 max-md:order-first"
					data-sal="slide-right"
					data-sal-duration="1000"
				>
					<TextComponent
						variant="h1"
						className="font-title"
					>
						Soluciones
					</TextComponent>
					<TextComponent variant="h5">
						El <span className="font-semibold text-cyan-600">ambiente marino de Tacna</span> es una{" "}
						<span className="font-bold text-green-600">riqueza biológica, económica y cultural</span> que enfrenta <span className="font-semibold text-red-600">desafíos reales</span> pero
						también tiene <span className="font-bold text-green-600">oportunidades claras de recuperación</span>. A través de una combinación de{" "}
						<span className="font-semibold">educación, control, infraestructura y compromiso comunitario</span>, es posible{" "}
						<span className="font-bold text-green-600">restaurar y conservar este valioso ecosistema</span>.
					</TextComponent>

					<Button
						color="blue"
						className="w-fit"
						onClick={() => handleNavigate("soluciones")}
						secondary
					>
						Mas información →
					</Button>
				</Column>
				<img
					className="md:w-2/5 h-60 object-cover rounded-lg"
					data-sal="slide-left"
					data-sal-duration="1000"
					src="https://cdn.www.gob.pe/uploads/document/file/5524451/877942-407350685_666098595708989_1426217556634878249_n.jpg"
					alt="representacion de la contamiinación minera"
				/>
			</Row>
			<Row
				className="gap-5 relative"
				crossAxisAlignment="center"
				mainAxisAlignment="center"
				flexible
				responsiveCol
			>
				<div className="absolute bg-black/30 top-0 left-0 w-full h-full" />
				<Column className="self-center py-10 pt-28 max-md:px-4 md:py-20 md:pt-48 rounded-lg sm:w-[40rem] md:w-[50rem] xl:w-[60rem]">
					<TextComponent
						variant="big"
						className="mt-2 font-title z-[1] text-white text-center"
						data-sal="zoom-out"
						data-sal-duration="1000"
					>
						¡Sumérgete en la lucha por su preservación!
					</TextComponent>
				</Column>
				<img
					className="w-full h-full object-cover absolute top-0 left-0"
					src="/olas.svg"
					alt="representacion del mundo contaminado"
				/>
			</Row>
		</>
	);
};
